import * as React from 'react';
import { withLayoutRenderComplete, ILayoutRenderProps } from '../decorators/withLayoutRenderComplete';

/**
 * @public
 */
export interface IWithLayoutRenderCompleteProps extends ILayoutRenderProps {
    // Nothing added.
}

/**
 * Component which wraps content and reports when they have mounted or updated.
 * Used for tracking PLT and navigation performance.
 * @public
 */
export const WithLayoutRenderComplete: React.ComponentType<IWithLayoutRenderCompleteProps> =
    withLayoutRenderComplete()(React.Fragment);
